import Card from '@material-tailwind/react/Card';
import CardHeader from '@material-tailwind/react/CardHeader';
import CardBody from '@material-tailwind/react/CardBody';
import { updateProfile, getCompanyAdminDetails, resetUpdateProfileData } from "Services/action";
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from 'react';
import Button from '@material-tailwind/react/Button';
import { useNavigate } from 'react-router-dom';
import loader from "assets/img/loading.gif";

import { ToastContainer, toast } from "react-toastify";


export default function SettingsForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [base64Image, setBase64Image] = useState('');

    const errorNotify = (error) =>
        toast.error(error, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

    const successNotify = (succesData) =>
        toast.success(succesData, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    const companyAdminData = useSelector((state) => state?.CompanyAdminDetail?.companyAdminDetailRec);
    const ref = useRef(null);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    function onSubmit(companyData) {
        companyData.id = companyAdminData?.id;
        companyData.companyLogo = base64Image;
        dispatch(updateProfile(companyData));

    }
    const UpdateProfileData = useSelector((state) => state?.UpdateProfile);

    useEffect(() => {
        if (UpdateProfileData?.store_request == true) {
            setLoading(true);
        }
        if (UpdateProfileData?.success == true) {
            setLoading(false);

            let succesData = "Profile Updated Successfully"
            successNotify(succesData);

            const data = {
                id: companyAdminData?.id
            }
            dispatch(getCompanyAdminDetails(data));
            dispatch(resetUpdateProfileData())
        }
        if (UpdateProfileData?.error) {
            setLoading(false);
            let errorData = UpdateProfileData?.message
            errorNotify(errorData);
        }
    }, [UpdateProfileData])

    const [logoImg, setlogoImg] = useState();
    function handleChange(e) {
        setlogoImg(URL.createObjectURL(e.target.files[0]));

        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setBase64Image(reader.result);
            };
            reader.readAsDataURL(file);
        }

    }
    return (
        <Card>
            <ToastContainer />
            <CardHeader contentPosition="none">
                <div className="w-full flex items-center justify-between">
                    <h2 className="text-white text-2xl">Profile</h2>
                </div>
            </CardHeader>
            <CardBody>
                <form className='custom-form form-student-set' onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex flex-wrap mt-10">
                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative h-11">
                                <input {...register("name", { required: true })}
                                    defaultValue={companyAdminData && companyAdminData?.name}
                                    placeholder="Names:" required className="w-full h-full focus:outline-none" />
                                {errors.name && <span className="error"> Name is required.</span>}
                            </div>
                        </div>

                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative h-11">
                                <input {...register("license", { required: true })}
                                    defaultValue={companyAdminData && companyAdminData?.license}
                                    placeholder="License:" required className="w-full h-full focus:outline-none" />
                                {errors.license && <span className="error"> License is required.</span>}
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative h-11">
                                <input type="number" {...register("phone_no", {
                                    required: true,
                                    minLength: 10, // Minimum character length
                                    maxLength: 10, // Maximum character length
                                })}
                                    defaultValue={companyAdminData && companyAdminData?.phone_no}
                                    placeholder="Phone:" required className="w-full h-full remove-arrow focus:outline-none"
                                    onInput={(e) => {
                                        if (e.target.value.length > 10) {
                                            e.target.value = e.target.value.slice(0, 10); // Truncate the value to 10 characters
                                        }
                                    }} />
                                {errors.phone_no && <span className="error"> Phone is required.</span>}
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative h-11">
                                <input type="text" {...register("city", { required: true })}
                                    defaultValue={companyAdminData && companyAdminData?.city}
                                    placeholder="City:" required className="w-full h-full focus:outline-none" />
                                {errors.city && <span className="error"> City is required.</span>}
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative h-11">
                                <input type="text" {...register("state", { required: true })}
                                    defaultValue={companyAdminData && companyAdminData?.state}
                                    placeholder="State:" required className="w-full h-full focus:outline-none" />
                                {errors.state && <span className="error">  State is required.</span>}
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative h-11">
                                <input type="text" {...register("country", { required: true })}
                                    defaultValue={companyAdminData && companyAdminData?.country}
                                    placeholder="Country:" required className="w-full h-full focus:outline-none" />
                                {errors.country && <span className="error"> Country is required.</span>}
                            </div>
                        </div>

                        <div className="w-full lg:w-12/12 pr-4 ml-2 mb-2 font-light">
                            <div class="w-full relative h-11 font-bold">
                                <input type="checkbox" id="hide_expired_workers" name="hide_expired_workers" {...register("hide_expired_workers")} defaultChecked={companyAdminData && companyAdminData?.hide_expired_workers} /> &nbsp;&nbsp; Hide Expired Workers
                            </div>
                        </div>

                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light">
                            <div class="w-full relative">
                                {companyAdminData?.companyLogo ? <img src={companyAdminData?.companyLogo} style={{ width: "100px", height: "100px", float: "left", marginRight: "20px" }} /> : null}

                                {logoImg ? <img src={logoImg} style={{ width: "100px", float: "left", marginRight: "20px" }} /> : null}
                                <input type="file" onChange={handleChange} className="w-full h-full focus:outline-none" />
                            </div>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-full lg:w-6/12 pr-4 mb-10 font-light btn-w-full">
                            <Button className="form-button" type="submit" disabled={loading && loading == true} >{loading && loading == true ? <img style={{ width: "25px", marginRight: "15px" }} src={loader} /> : null}
                                Submit</Button>
                        </div>
                    </div>
                </form>
            </CardBody>
        </Card>
    );
}
